import { render, staticRenderFns } from "./SpecialContents.vue?vue&type=template&id=e5c2722c&scoped=true"
import script from "./SpecialContents.vue?vue&type=script&lang=js"
export * from "./SpecialContents.vue?vue&type=script&lang=js"
import style0 from "./SpecialContents.vue?vue&type=style&index=0&id=e5c2722c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5c2722c",
  null
  
)

export default component.exports